import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface NotiState {
  count: number;
}

const initialState: NotiState = {
  count: 0,
};

export const NotificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    actionCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { actionCount } = NotificationSlice.actions;

export default NotificationSlice.reducer;
